// extracted by mini-css-extract-plugin
module.exports = {"hoverLink":"style_hoverLink__cidZ3"};